$(document).ready(function(){
 // $('#quantity').change(function(){
  $('body').on('input', '#quantity', function() {
  	var quant = $(this).val();
    var min = $(this).attr('min');
      var min = parseInt(min);
    if(quant < min)
    {
      $(this).val(min);
    }
  });
   $('body').on('input', '.hup_quantity_cart', function() {
//  $('.hup_quantity_cart').change(function(){
  	var quant = $(this).val();
    var min = $(this).parent().parent().attr('data-value');
       var min = parseInt(min);
    if(quant < min)
    {
      $(this).val(min);
    }
  });
//     $(document).bind("contextmenu",function(e) {
//     e.preventDefault();
//   });
//   $(document).keydown(function (event) {
//     if (event.keyCode == 123) { // Prevent F12
//       return false;alert(1);
//     } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I        
//       return false;
//     }
//   });
   $('.hup_quantity_cart').change(function(){
    setTimeout(function(){ 	$('#update-cart.hup_checkout_button').removeAttr('disabled'); }, 50);
  });
    $('.hup_quantity_cart').change(function(){
    setTimeout(function(){ 	$('#update-cart.hup_checkout_button').removeAttr('disabled'); }, 50);
  });
});



$(document).ready(function(){
$('body').fadeIn(2000).delay(2000);
  $(document).on("click",".mobileNav", function(){
  $(".is-mobile .menu-mobile").addClass("showmobilenav");
  });
  $(document).on("click",".menu-mobile .nav_close", function(){
  $(".is-mobile .menu-mobile").removeClass("showmobilenav");
});
  $(document).on("click",".parent_submenu .expand", function(){
  $(this).next(".dropdown_menu").toggleClass("showmobilesubnav");
  });
});